import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { Estimate } from "types/Estimate";

import { clientConfigAtom } from "./clientConfig";
import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionEstimateAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<Estimate | null>(`estimate-${sessionId}`, null)
);

export const estimateAtom = createDerivedSessionAtom<Estimate | null>(sessionEstimateAtom);

export const estimateTotalAtom = atom((get) => {
  const { estimate: estimateConfig } = get(clientConfigAtom);
  const estimate = get(estimateAtom);

  return estimateConfig?.repairable?.includeTaxInTotal ? estimate?.totalIncludingTax : estimate?.totalExcludingTax;
});
